import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import {
  ShopInsuranceContent,
  type PaymentOption,
  type ShopInsuranceMode,
} from '@/features/shop-insurance';

export function ShopInsurancePage({ clientId }: ClientIdProps) {
  const navigate = useNavigate();

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    html.style.height = '100vh';
    body.style.height = '100vh';
    return () => {
      html.style.overflow = '';
      body.style.overflow = '';
      html.style.height = '';
      body.style.height = '';
    };
  }, []);

  const [searchParams] = useSearchParams();

  const queryOptions = useMemo(
    () => ({
      paymentOption: (searchParams.get('paymentOption')?.replace('_', ' ') ?? undefined) as
        | PaymentOption
        | undefined,
      buyerOption: (searchParams.get('buyerOption') ?? undefined) as
        | '1-buyer'
        | '2-buyer'
        | undefined,
      selectTabOption: (searchParams.get('selectTabOption') ?? undefined) as
        | ShopInsuranceTab
        | undefined,
      mode: (searchParams.get('mode') ?? undefined) as ShopInsuranceMode | undefined,
    }),
    [searchParams],
  );

  const handleClose = useCallback(() => {
    navigate(`/clients/${clientId}/onboarding/funding-sources`);
  }, [navigate, clientId]);

  return (
    <div className="bg-background flex h-screen flex-col overflow-hidden">
      <ShopInsuranceContent
        onClose={handleClose}
        queryOptions={queryOptions}
      />
    </div>
  );
}
